import React from "react";
import { MapPin } from "lucide-react";

const Navbar = () => {
  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-backdrop-filter:bg-background/60">
      <div className="container flex h-16 w-full items-center justify-between px-4 bg-white/90">
        <div className="flex items-center gap-2">
          <img
            src="/logo.png"
            alt="STMJ Mandor Logo"
            className="h-12 w-12 object-contain rounded-full"
          />
          <div>
            <h1 className="text-lg font-bold leading-none">STMJ Mandor</h1>
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <MapPin className="h-3 w-3" />
              <span>Jl. Raya Tlogomas No. 47</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
